export default __webpack_public_path__ + "static/media/NFT_3.eda66f63.jpeg";